/** Shown when a rerun job's saved template was replaced with the latest active one. */
export const RERUN_TEMPLATE_FALLBACK_MESSAGE =
  "Your previously selected template was updated. We've selected the latest available version.";

/** Resolve template id/name from GET /jobs/:id/rerun-data (server may apply fallback). */
export function resolveRerunTemplate(rerunData) {
  const templateId = rerunData?.template_id || '';
  const templates = rerunData?.available_templates || [];
  const match = templates.find((t) => t.id === templateId);
  return {
    templateId,
    templateName: match?.name || '',
    fallbackUsed: Boolean(rerunData?.template_fallback_used),
  };
}

/** Merge resolved template id/name into the current wizard URL search params. */
export function applyRerunTemplateToSearchParams(searchParams, { templateId, templateName }) {
  const sp = new URLSearchParams(
    typeof searchParams === 'string' ? searchParams : searchParams.toString(),
  );
  if (templateId) sp.set('templateId', templateId);
  if (templateName) sp.set('templateName', templateName);
  return sp;
}
